import { SVGProps } from "react";

const CardHero2MobUnderline = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 169 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.00171 10C38.1615 1.93457 131.201 13.368 162.002 7.35523"
        stroke="#FFA686"
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CardHero2MobUnderline;
